import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveGame, selectGameTurn } from '../ActiveGame/selectors';
import { PlainButton } from '../Controls';
import { coinFlipLines } from './coinFlipLines';
import { isRecentFlip } from './isRecentFlip';
import { Notice } from './styled';

/**
 * The latest coin flips, for both players, until dismissed. The server tags them with the game version they
 * happened in, so a later flip shows again after an earlier one was dismissed, and the turn, so old ones don't come
 * back with every visit (the activity log keeps them all).
 */
const CoinFlips = () => {
  const coinFlips = useSelector(selectActiveGame).get('coin_flips');
  const gameTurn = useSelector(selectGameTurn);
  const [dismissedVersion, setDismissedVersion] = useState(null);

  if (!coinFlips || coinFlips.get('version') === dismissedVersion
    || !isRecentFlip(coinFlips.get('turn'), gameTurn ? gameTurn.get('number') : 0)) {
    return null;
  }

  return (
    <Notice role="status" aria-label="Coin flips">
      <ul>
        {coinFlipLines(coinFlips.get('flips').toJS()).map(line => <li key={line}>{line}</li>)}
      </ul>
      <PlainButton onClick={() => setDismissedVersion(coinFlips.get('version'))}>OK</PlainButton>
    </Notice>
  );
};

export default CoinFlips;
